import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
import { getClientId } from "../../utils/config";
var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query RefreshToken($client: String!) {\n    refreshToken(clientId: $client) {\n      tokens {\n        accessToken\n        idToken\n        expires\n      }\n    }\n  }\n"])));
async function refresh() {
  var data = await wrapQuery('refresh', query, {
    client: getClientId()
  });
  return data.refreshToken.tokens;
}
export { refresh };